import styled from 'styled-components'
import { colors } from '@diversioteam/diversio-ds'

export const BannerContainer = styled.div`
    background: ${colors.primary10};
    border: 1px solid ${colors.primary20};
    color: ${colors.primary80};
    padding: 8px 12px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background: ${colors.primary20};
    }
`

export const BannerText = styled.div`
    font-size: 13px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${colors.primary60};

    strong {
        font-weight: 600;
        color: ${colors.primary60};
    }
`

export const TimerText = styled.span`
    color: #ea580c;
    font-weight: 500;
`

export const Actions = styled.div`
    display: flex;
    gap: 8px;
`
